// src/data/row-query.ts
function comparable(value) {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value instanceof Date;
}
function order(a, b) {
  const x = a instanceof Date ? a.getTime() : a;
  const y = b instanceof Date ? b.getTime() : b;
  if (x === y) return 0;
  return x < y ? -1 : 1;
}
function listOf(value) {
  return Array.isArray(value) ? value : null;
}
function rowMatches(row, filter) {
  const value = row[filter.field];
  const target = filter.value;
  if (value === null || value === void 0) return filter.op === "!=" && target !== null && target !== void 0;
  switch (filter.op) {
    case "==":
      return value === target;
    case "!=":
      return value !== target;
    case ">":
      return comparable(target) && comparable(value) && order(value, target) > 0;
    case ">=":
      return comparable(target) && comparable(value) && order(value, target) >= 0;
    case "<":
      return comparable(target) && comparable(value) && order(value, target) < 0;
    case "<=":
      return comparable(target) && comparable(value) && order(value, target) <= 0;
    case "in":
      return listOf(target)?.includes(value) ?? false;
    case "not-in":
      return !(listOf(target)?.includes(value) ?? true);
    case "contains":
      return typeof value === "string" && typeof target === "string" && value.toLowerCase().includes(target.toLowerCase());
    case "array-contains":
      return target !== void 0 && (listOf(value)?.includes(target) ?? false);
    case "array-contains-any": {
      const have = listOf(value);
      const want = listOf(target);
      return have !== null && want !== null && want.some((v) => have.includes(v));
    }
  }
}
function filterRows(rows, filters) {
  return rows.filter((row) => filters.every((filter) => rowMatches(row, filter)));
}
function searchRows(rows, search, fields) {
  if (!search || !search.trim()) return [...rows];
  const needle = search.toLowerCase();
  return rows.filter((row) => (fields ?? Object.keys(row)).some((field) => {
    const value = row[field];
    return value !== null && value !== void 0 && String(value).toLowerCase().includes(needle);
  }));
}
function sortRows(rows, sortBy, sortOrder = "asc") {
  if (!sortBy) return [...rows];
  return [...rows].sort((a, b) => {
    const x = a[sortBy];
    const y = b[sortBy];
    const xMissing = x === null || x === void 0;
    const yMissing = y === null || y === void 0;
    if (xMissing || yMissing) return xMissing === yMissing ? 0 : xMissing ? 1 : -1;
    if (!comparable(x) || !comparable(y)) return 0;
    const c = order(x, y);
    return sortOrder === "asc" ? c : -c;
  });
}
function pageRows(rows, request) {
  const matched = sortRows(searchRows(filterRows(rows, request.filters ?? []), request.search, request.searchFields), request.sortBy, request.sortOrder);
  const start = (request.page - 1) * request.pageSize;
  return { rows: matched.slice(start, start + request.pageSize), total: matched.length };
}

export { filterRows, pageRows, rowMatches, sortRows };
//# sourceMappingURL=chunk-HK67P37H.js.map
//# sourceMappingURL=chunk-HK67P37H.js.map